import { render, staticRenderFns } from "./FaqAndSupportContactsCardWithCopy.vue?vue&type=template&id=2b499745&scoped=true"
import script from "./FaqAndSupportContactsCardWithCopy.vue?vue&type=script&lang=js"
export * from "./FaqAndSupportContactsCardWithCopy.vue?vue&type=script&lang=js"
import style0 from "./FaqAndSupportContactsCardWithCopy.vue?vue&type=style&index=0&id=2b499745&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b499745",
  null
  
)

export default component.exports